import { Model } from 'api/Exec/types';
import { formatDateTime } from 'app/helpers/dateTime';

import React, { CSSProperties } from 'react';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { Descriptions, Typography } from 'antd';
import type { DescriptionsProps } from 'antd';

interface Props {
  model: Model | null;
}

const DetailedDockerImage: React.FC<Props> = ({ model }) => {
  if (!model) {
    return null;
  }

  const positiveStyles: CSSProperties = { color: '#00B96B', marginRight: 8 };
  const negativeStyles: CSSProperties = { color: '#D9D9D9', marginRight: 8 };

  const items: DescriptionsProps['items'] = [
    {
      label: 'Model API',
      children: model.modelApiName,
    },
    {
      label: 'Push date',
      span: 'filled',
      children: formatDateTime(model.imagePushedAt),
    },
    {
      label: 'Image tag',
      span: 'filled',
      children: model.imageTag,
    },
    {
      label: 'Full image tag',
      span: 'filled',
      children: model.fullImageTag,
    },
    {
      label: 'Digest',
      span: 'filled',
      children: model.imageDigest,
    },
    {
      label: 'Git commit',
      span: 'filled',
      children: <Typography.Link href={model.gitCommit} target="_blank">{model.gitCommit}</Typography.Link>,
    },
    {
      label: (
        <>
          {model.isSandbox ? <CheckCircleFilled style={positiveStyles} /> : <CloseCircleFilled style={negativeStyles} />}
          Sandbox
        </>
      ),
      span: 'filled',
      children: 'Model is a sandbox with random data',
    },
    {
      label: (
        <>
          {model.clinicalValidated ? <CheckCircleFilled style={positiveStyles} /> : <CloseCircleFilled style={negativeStyles} />}
          Clinical validated
        </>
      ),
      span: 'filled',
      children: 'Model passed process of Clinical validation',
    },
    {
      label: 'Validated at',
      span: 'filled',
      children: model.validatedAt && formatDateTime(model.validatedAt),
    },
    {
      label: 'Validated by',
      span: 'filled',
      children: model.validatedBy,
    },
    {
      label: 'Named models',
      span: 'filled',
      children: model.assignedName,
    },
    {
      label: 'Description',
      span: 'filled',
      children: model.description,
    },
  ];

  return <Descriptions bordered title={`ID: ${model.id}`} items={items} column={2} />;
};

export default DetailedDockerImage;
